import * as React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import { useImageSrc } from "../../hooks";
import HeaderMenu from "./HeaderMenu";
import { IMAGES } from "../../themes";
import { ThemeSwitcher } from "../Theme";
import { usePageContext } from "../Page";
import { HEADER_HEIGHT } from "../../constants/values";
const useStyles = makeStyles(({
  palette,
  typography,
  breakpoints
}) => ({
  wrapper: {
    zIndex: 1000,
    background: palette.background.default,
    height: typography.pxToRem(HEADER_HEIGHT)
  },
  logo: {
    maxHeight: typography.pxToRem(37),
    margin: typography.pxToRem(15),
    [breakpoints.down("xs")]: {
      maxHeight: typography.pxToRem(30),
      margin: typography.pxToRem(12),
      marginLeft: typography.pxToRem(0),
      marginRight: typography.pxToRem(0)
    }
  },
  menuTitle: {
    fontSize: typography.pxToRem(22),
    fontWeight: 300,
    lineHeight: 1.3,
    letterSpacing: typography.pxToRem(0.8),
    color: palette.text.primary,
    fontFamily: typography.fontFamily,
    textTransform: "none",
    textAlign: "center",
    whiteSpace: "normal",
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(17)
    }
  },
  switchContainer: {
    textAlign: "right"
  }
}));

const Header = ({
  pathname,
  onSwitchTheme
}) => {
  const styles = useStyles();
  const logoSrc = useImageSrc(IMAGES.LOGO);
  const {
    title,
    headerMenuActions,
    isMobileMenuShevronVisible
  } = usePageContext();
  const menuActions = React.useMemo(() => headerMenuActions.map(([label, control]) => ({
    label,
    ...control
  })), [headerMenuActions]);
  const label = /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: styles.menuTitle
  }, title);
  return /*#__PURE__*/React.createElement(AppBar, {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    lg: 3,
    xs: 3,
    sm: 3
  }, /*#__PURE__*/React.createElement("img", {
    src: logoSrc,
    className: styles.logo,
    alt: "DPD"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    lg: 6,
    xs: 6,
    sm: 6
  }, menuActions.length ? /*#__PURE__*/React.createElement(HeaderMenu, {
    actions: menuActions,
    pathname: pathname,
    isMobileMenuShevronVisible: isMobileMenuShevronVisible
  }, label) : label), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    lg: 3,
    xs: 3,
    sm: 3,
    className: styles.switchContainer
  }, /*#__PURE__*/React.createElement(ThemeSwitcher, {
    onSwitch: onSwitchTheme
  })))));
};

Header.propTypes = {
  pathname: PropTypes.string,
  onSwitchTheme: PropTypes.func
};
Header.defaultProps = {
  pathname: ""
};
export default Header;